import { Platform, ViewStyle } from "react-native";
import styled from "@emotion/native";
import Text from "../../components/Text";
import * as drawer from "../../utils/drawer";

export const Container = styled.View(
	{
		flex: 1,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.background,
		};
	}
);
export const Background = styled.Image({
	position: "absolute",
	width: "100%",
	height: "100%",
	resizeMode: "cover",
});
export const Title = styled(Text)(
	{
		marginTop: drawer.BUTTON_TOP,
		marginLeft: 20,
		marginRight: 20,
	},
	({ theme }: any) => {
		let style: ViewStyle = {};

		if (theme.verticalScale < 1) {
			const marginTop = drawer.BUTTON_TOP * theme.verticalScale;

			style = {
				marginTop,
			};
		}

		return style;
	}
);
export const Body = styled.ScrollView(
	{
		marginTop: drawer.BUTTON_TOP + drawer.BUTTON_HEIGHT,
		overflow: Platform.OS === "android" ? "scroll" : "visible",
	},
	({ theme }: any) => {
		let style: ViewStyle = {};

		if (theme.verticalScale < 1) {
			const marginTop =
				(drawer.BUTTON_TOP + drawer.BUTTON_HEIGHT) *
				theme.verticalScale;

			style = {
				marginTop,
			};
		}

		return style;
	}
);

Body.defaultProps = {
	contentContainerStyle: { flexGrow: 1 },
};

export const DrawerButtonContainer = styled.View({
	position: "absolute",
	width: 60,
	height: 60,
	left: 12,
	top: 40,
	zIndex: 10,
	alignItems: "center",
	justifyContent: "center",
});

export const StrategyList = styled.View({
	flexDirection: "column",
	marginBottom: 10,
	marginHorizontal: 0,
	marginTop: 30,
});
